

export class ProdutoCodigoPreCadastroFormModel {
  constructor(public codigo = "", public codigoEAN?: string) {}
}
